import React from "react";

import { MyBusinessCardStateProviderProps } from "./types";
import { propositionToFranchiseDetail } from "./helpers";
import MyBusinessCard from "./MyBusinessCard";

const StateProvider: React.FC<MyBusinessCardStateProviderProps> = ({
  propositions,
  franFreeDaysBalance,
  loading,
}) => {
  const franchiseDetails = propositions
    ? propositions.map(p => ({
        ...propositionToFranchiseDetail(p),
        franchiseFreeDays: franFreeDaysBalance
          ? franFreeDaysBalance.toString()
          : "0",
      }))
    : undefined;

  return (
    <MyBusinessCard loading={loading} franchiseDetails={franchiseDetails} />
  );
};

export default StateProvider;
